<ng-container *ngIf="(user$ | async) as user">
  <app-program-copy-button
    *ngIf="program && (user.roles.admin || user.roles.editor)"
    class="btn btn-secondary"
    [user]="user"
    [program]="program"
  ></app-program-copy-button>
</ng-container>
